import * as React from 'react';

declare var redirectUrl: string;
redirectUrl = redirectUrl.length > 0 ? redirectUrl : "/";

interface ExitProps {

}

const exit: React.SFC<ExitProps> = (props) => {
    return (
        <a href={redirectUrl} className="cal-nav-exit">
            <p>Close</p>

            <svg className="svg-icon-md">
                <use xlinkHref="#icon-close-x" />
            </svg>
        </a>
    );
}

export default exit;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/views/exit.tsx